export const MIN_AUDIO_DURATION = 30; // 30 seconds
export const MAX_AUDIO_DURATION = 480; // 8 minutes

export const DROPZONE_CONFIG = {
  maxFiles: 1,
  minDuration: MIN_AUDIO_DURATION,
  maxDuration: MAX_AUDIO_DURATION,
  accept: {
    'audio/wav': ['.wav'],
  },
  noClick: true,
};
